// Utils
import { SearchPageLinkType, SearchPageLinkPartial } from './search-links';

type Section = {
  label: string;
  links: SearchPageLinkPartial[];
};

export const categorizeLinks = (links: SearchPageLinkPartial[]): Section[] => {
  const sections: { [key in SearchPageLinkType]?: SearchPageLinkPartial[] } =
    {};

  // Categorize links based on their type
  links.forEach((link) => {
    if (!sections[link.type]) {
      sections[link.type] = [];
    }
    // @ts-ignore
    sections[link.type].push(link);
  });

  // Convert the categorized links into sections
  return Object.entries(sections).map(([type, links]) => {
    let label;
    switch (type) {
      case SearchPageLinkType.City:
        label = 'Nearby Cities';
        break;
      case SearchPageLinkType.Attraction:
        label = 'Nearby Attractions';
        break;
      case SearchPageLinkType.SimilarArea:
        label = 'Similar Areas';
        break;
      case SearchPageLinkType.Blog:
        label = 'Related Blogs';
        break;
      default:
        label = 'Other';
    }
    return { label, links };
  });
};
